import { CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";

export const formatToNational = (phoneNumber: string | null, country: CountryCode): string => {
  if (!phoneNumber) return "";
  const parsedNumber = parsePhoneNumberFromString(phoneNumber, country);
  return parsedNumber ? parsedNumber.format("NATIONAL") : "";
};

export const formatToE164 = (phoneNumber: string | null, country: CountryCode): string => {
  if (!phoneNumber) return ""; 
  const parsedNumber = parsePhoneNumberFromString(phoneNumber, country);
  return parsedNumber ? parsedNumber.format("E.164") : "";
};